import React, { useEffect, useState, useCallback } from 'react';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Typography,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CircularProgress from '../CircularProgress';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PersonIcon from '@material-ui/icons/Person';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import RateScheduleIcon from '../../Assets/icons/IconsJsx/RateScheduleIcon';
import SuccessModal from '../SuccessModal';
const Steps = [
  { key: '1', label: 'Create Location', icon: LocationOnIcon },
  { key: '2', label: 'Create Rate Schedule', icon: RateScheduleIcon },
  { key: '3', label: 'Create Display', icon: DesktopWindowsIcon },
  { key: '4', label: 'Connect a Stripe Account', icon: AccountBalanceWalletIcon },
  { key: '5', label: 'Upload Avatar', icon: AccountCircleIcon },
  { key: '6', label: '', icon: PersonIcon },
];

const CustomStepIcon = ({ icon: StepIcon, stepKey, activeStep, steps, isHovered }) => {
  const key = steps[stepKey];
  const iconColor = (isHovered === activeStep && !key.isCompleted) ? '#623C91' :
    key.isCompleted
      ? 'green'
      : key.isActive
        ? '#623C91'
        : 'gray';

  return (
    <Box
      sx={{
        color: iconColor,
        cursor: !(key.isCompleted) ? 'pointer' : 'not-allowed',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        transition: 'color 0.3s ease',
        '&:hover': !key.isCompleted && {
          color: '#623C91',
        },
      }}
    >
      {!key.isCompleted ? <StepIcon fontSize="small" className="w-5 h-5" fill={iconColor} /> : <CheckCircleIcon fontSize="small" />}
    </Box>
  );

};

const CustomStepper = ({ getStep, updateProgressStep, steps, skippedProgressStep, updateScore, profileUpdate }) => {
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [hoverStep, setHoveredStep] = useState(null);
  const [open, setOpen] = useState(true);
  const getCurrentStep = useCallback(async () => {
    await getStep();
  }, [getStep]);

  const updateScoreAsync = useCallback(async (count) => {
    await updateScore(count);
  }, [updateScore]);

  useEffect(() => {
    getCurrentStep();
  }, [getCurrentStep]);

  useEffect(() => {
    let count = 0;
    Object.keys(steps).forEach((obj) => {
      const key = steps[obj];
      if (key.isCompleted || key.isSkipped) {
        count += key.points;
      }
    });
    setScore(count);
    if (count >= 0)
      updateScoreAsync(count);

  }, [steps, updateScoreAsync]);

  const handleSkipped = async (key) => {
    await skippedProgressStep(key);
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const data = {
      id: userInfo?.id,
      isUserSkipped: true,
    }
    await profileUpdate(data);
  };

  const handleRoute = (key) => {
    switch (key) {
      case '1':
        navigate('/locations');
        updateProgressStep(1)
        getStep();
        break;
      case '2':
        navigate('/rate-schedules');
        updateProgressStep(2);
        getStep();
        break;
      case '3':
        navigate('/displays');
        updateProgressStep(3);
        getStep();
        break;
      case '4':
        navigate('/settings');
        updateProgressStep(4);
        getStep();
        break;
      case '5':
        navigate('/settings/:profile');
        updateProgressStep(5);
        getStep();
        break;
      case '6':
        navigate('/users');
        updateProgressStep(6);
        getStep();
        break;
      default:
        break;
    }
  };
  return (
    <Box sx={{ width: '90%', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginLeft: '6%', fontFamily: 'Roboto, Helvetica, Arial, sans-serif' }}>
      {score === 100 ?
        <div>
          <SuccessModal isOpen={open} onClose={() => setOpen(false)} userType="DSO" modalHeight="280px" />
        </div> :
        <>
          <div style={{ width: '80%' }}>
            <Stepper>
              {Steps.map((stepObj) => {
                const obj = steps[stepObj.key];
                if (stepObj.key === '6') {
                  return (
                    <Step
                      key={stepObj.key}
                      sx={{ overflowX: 'auto', maxWidth: '90px', display: 'inline-flex', scrollbarWidth: 'none', textAlign: 'left' }}
                    >
                      <StepLabel
                        StepIconComponent={(iconProps) => (
                          <CustomStepIcon
                            {...iconProps}
                            stepKey={stepObj.key}
                            activeStep={stepObj.key}
                            steps={steps}
                            icon={stepObj.icon}
                            isHovered={hoverStep}
                          />
                        )}
                      >
                        <Typography
                          variant="body1"
                          style={{
                            cursor: !(obj.isCompleted) ? 'pointer' : 'not-allowed',
                            transition: 'color 0.2s',
                            color: obj.isDisable ? 'gray' : 'black',
                            overflowX: 'scroll',
                            fontSize: '12px',
                            display: 'inline-flex',
                            minWidth: '60px',
                            scrollbarWidth: 'none',
                          }}
                          onMouseEnter={() => setHoveredStep(stepObj.key)}
                          onMouseLeave={() => setHoveredStep(null)}
                          onClick={!(obj.isCompleted) ? () => handleRoute(stepObj.key) : undefined}
                        >
                          Add Team Member
                        </Typography>
                        <Typography
                          style={{
                            cursor: !(obj.isCompleted) ? 'pointer' : 'not-allowed',
                            transition: 'color 0.2s',
                            color: !(obj.isCompleted) ? 'inherit' : 'gray',
                            fontSize: '12px',
                          }}
                          onClick={!(obj.isCompleted) ? () => handleSkipped(stepObj.key) : undefined}
                          onMouseEnter={() => setHoveredStep(stepObj.key)}
                          onMouseLeave={() => setHoveredStep(null)}
                        >(Skip)</Typography>
                      </StepLabel>
                    </Step>
                  );
                }
                return (
                  <Step
                    key={stepObj.key}
                    sx={{
                      overflowX: 'scroll',
                      display: 'inline-flex',
                      maxWidth: '90px',
                      scrollbarWidth: 'none',
                      textAlign: 'left'
                    }}

                  >
                    <StepLabel
                      StepIconComponent={(iconProps) => (
                        <CustomStepIcon
                          {...iconProps}
                          stepKey={stepObj.key}
                          activeStep={stepObj.key}
                          icon={stepObj.icon}
                          steps={steps}
                          isHovered={hoverStep}
                        />
                      )}
                    >
                      <Typography
                        variant="body1"
                        style={{
                          cursor: !(obj.isCompleted) ? 'pointer' : 'not-allowed',
                          transition: 'color 0.2s',
                          color: obj.isDisable ? 'gray' : 'black',
                          fontSize: '12px',
                          overflowX: 'scroll',
                          display: 'inline-flex',
                          maxWidth: '90px',
                          scrollbarWidth: 'none',
                        }}
                        onMouseEnter={() => setHoveredStep(stepObj.key)}
                        onMouseLeave={() => setHoveredStep(null)}
                        onClick={!(obj.isCompleted) ? () => handleRoute(stepObj.key) : undefined}

                      >
                        {stepObj.label}
                      </Typography>
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>

          </div>
          <div style={{ width: '9%', marginLeft: '1rem' }}>
            <CircularProgress value={score} data={steps} />
          </div>
        </>

      }
    </Box>
  );
};

const mapState = (state) => ({
  step: state.ProgressStepDSO.step,
  steps: state.ProgressStepDSO.steps,
});
const mapDispatch = (dispatch) => ({
  getStep: (data) =>
    dispatch.ProgressStepDSO.GetDSOProgressStep(data),
  updateProgressStep: (data) =>
    dispatch.ProgressStepDSO.UpdateDSOProgressStep(data),
  skippedProgressStep: (data) =>
    dispatch.ProgressStepDSO.SkippedDSOProgressStep(data),
  updateScore: (data) =>
    dispatch.ProgressStepDSO.UpdateProfileProgress(data),
  profileUpdate: (data) =>
    dispatch.ProgressStepDSO.UpdateProfileSkipped(data),
});
export default connect(mapState, mapDispatch)(CustomStepper);